import { UseQueryResult } from '@tanstack/react-query'

export function getSuccessData<T>(results: UseQueryResult<T, Error>[]) {
  return results.filter((r) => r.isSuccess).map((r) => r.data)
}
